
// import styles from "./SearchInput.module.css";

// export default function SearchInput({
//   value = "",
//   onChange,
//   placeholder = "Search State, City or Hotel...",
// }) {
//   return (
//     <input
//       className={styles.input}
//       type="search"
//       aria-label="Search states, cities or hotels"
//       placeholder={placeholder}
//       value={value}
//       onChange={(event) => onChange(event.target.value)}
//       autoComplete="off"
//     />
//   );
// }



import styles from "./SearchInput.module.css";

export default function SearchInput({
  value = "",
  onChange,
  onKeyDown,
  placeholder = "Search State, City or Hotel...",
}) {
  return (
    <input
      className={styles.input}
      type="search"
      aria-label="Search states, cities or hotels"
      aria-autocomplete="list"
      aria-expanded={Boolean(value.trim())}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={onKeyDown}
      autoComplete="off"
    />
  );
}
